import React from 'react';

interface LoaderProps {
  checkIn?: string;
  checkOut?: string;
}

const PageLoaderComponent: React.FC<LoaderProps> = ({}) => {
  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-85 z-50"></div>
      
      <div className="fixed inset-0 flex items-center justify-center z-50">
        <div className="bg-white p-6 rounded-lg shadow-lg w-72 text-center">

          <div className="relative w-24 h-24 mx-auto mb-4">
            {/* <div className="absolute inset-0 rounded-full border-t-4 border-pink-600 border-opacity-70 animate-spin"></div> */}
            <img 
              src="/general/baggage.gif"
              alt="Loading"
              className="absolute inset-0 w-full h-full object-cover rounded-full p-3"
            />
          </div>

          <div className="font-semibold text-gray-800 mb-2 text-xl">
            Dream. Discover. Save.
          </div>         

          {/* <div className="text-sm text-gray-600 mb-2">
            from {checkIn} to {checkOut}
          </div> */}

          <div className="font-medium text-black text-sm mt-2 mb-1">
            Your journey starts <span className='font-bold text-halo-pink'>here</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default PageLoaderComponent;
